'use client'

import { motion } from 'framer-motion'
import Link from 'next/link'
import classes from './TopBar.module.css'
import { transitionBase } from '@/lib/animations'
import { useBreakpoint } from '@/hooks/useBreakpoints'

export default function TopBar() {
    const { isSm } = useBreakpoint()

    return (
        <motion.div
            initial={{ opacity: 0.01, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={transitionBase}
            className={`${classes.container} ${isSm ? classes.mobileContainer : ''}`}
        >
            <div className={classes.flexWrapper}>
                <p className={`${classes.badge} ${isSm ? classes.mobileBadge : ''}`}>New</p>
                <p
                    className={`${classes.text} ${classes.textDesktop} ${isSm ? classes.mobileText : ''} ${isSm ? classes.mobileTextDesktop : ''}`}
                >
                    Ask General AI anything, and get recommendations for what to do next.
                </p>
                <p
                    className={`${classes.text} ${classes.textMobile} ${isSm ? classes.mobileText : ''} ${isSm ? classes.mobileTextMobile : ''}`}
                >
                    Get personalized health recommendations
                </p>
            </div>
            <Link href="/ai/" className={`${classes.link} ${isSm ? classes.mobileLink : ''}`}>
                Learn More
            </Link>
        </motion.div>
    )
}
